// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__EicVc","fade_left":"navbar_fade_left__EI7Yb","fade_bottom":"navbar_fade_bottom__EU9J5","link":"navbar_link__48gXS"};